import { ApiService } from '../ApiService';
import type { 
  AuditHistoryResponse, 
  AuditFiscalYearRequest,
  AuditListFilters,
  AuditListResponse,
  TokenRequest,
  TokenValidation
} from '../../../types/audit';

export const auditApi = {
  // Gestion des tokens d'audit
  requestToken: (credentials: TokenRequest) =>
    ApiService.post<{ success: boolean; message: string }>('/audit/request-token', credentials),

  validateToken: (validation: TokenValidation) =>
    ApiService.post<{ valid: boolean; message: string }>('/audit/validate-token', validation),

  // Audit des exercices comptables
  auditFiscalYear: (fiscalYearId: string, request: AuditFiscalYearRequest) =>
    ApiService.post<{ 
      success: boolean; 
      message: string; 
      fiscalYear: any; // Type from fiscal-year.ts
    }>(`/audit/fiscal-year/${fiscalYearId}`, request),

  // Historique d'audit pour un exercice spécifique
  getAuditHistory: (fiscalYearId: string) =>
    ApiService.get<AuditHistoryResponse>(`/audit/history/${fiscalYearId}`),

  // Liste de tous les audits
  getAuditList: (filters?: AuditListFilters) => {
    const params = new URLSearchParams();
    
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);
    if (filters?.auditorId) params.append('auditorId', filters.auditorId);
    if (filters?.status && filters.status !== 'all') params.append('status', filters.status);
    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.pageSize) params.append('pageSize', filters.pageSize.toString());

    const queryString = params.toString();
    const url = queryString ? `/audit/list?${queryString}` : '/audit/list';
    
    return ApiService.get<{ success: boolean; data: AuditListResponse }>(url);
  }
};